import "core-js/modules/es.number.constructor";
//
//
//
//
import * as echarts from 'echarts';

require('echarts/theme/macarons'); // echarts theme


import { debounce } from '@/utils';
export default {
  name: 'PieChart',
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    chartName: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    render: {
      type: Number,
      required: true
    },
    pieData: {
      type: Array,
      required: true
    },
    pieUnit: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      chart: null,
      defaultPalette: [// '#51689b', '#ce5c5c', '#fbc357', '#8fbf8f', '#659d84', '#fb8e6a', '#c77288', '#786090', '#91c4c5', '#6890ba'
      '#e5cf0f', '#dc69aa', '#41c7c8', '#b6a2de', '#5ab1ef', '#f9b980', '#d87a80', '#8d98b3', '#97b551', '#95706d'],
      radius: [30, 120],
      pieOption: {
        title: {
          text: '',
          left: 'left'
        },
        legend: {
          orient: 'vertical',
          right: 'right',
          top: 'top'
        },
        series: [{
          type: 'pie',
          radius: [],
          left: 'center',
          top: 20,
          itemStyle: {
            borderColor: '#fff',
            borderWidth: 1
          },
          label: {
            position: 'inside',
            formatter: '{d}%'
          },
          labelLine: {
            show: false
          },
          data: []
        }]
      }
    };
  },
  watch: {
    render: {
      deep: true,
      handler: function handler() {
        this.setOptionData();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initChart();

    if (this.autoResize) {
      this.__resizeHanlder = debounce(function () {
        if (_this.chart) {
          _this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHanlder);
    } // 监听侧边栏的变化


    var sidebarElm = document.getElementsByClassName('el-aside')[0];
    sidebarElm.addEventListener('transitionend', this.__resizeHanlder);
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHanlder);
    }

    var sidebarElm = document.getElementsByClassName('el-aside')[0];
    sidebarElm.removeEventListener('transitionend', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.pieOption.title.text = this.chartName;
      this.pieOption.series[0].radius = this.radius;
      this.setOptionData();
    },
    setOptionData: function setOptionData() {
      var seriesData = this.pieOption.series[0];
      seriesData.data = this.pieData;
      seriesData.label.formatter = this.pieUnit !== '' ? '{c}' + this.pieUnit + ', {d}%' : '{d}%';
      this.pieOption.series[0] = seriesData; // console.log('pie', this.pieOption)

      this.chart.setOption(this.pieOption, true);
    }
  }
};